import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalOverlay,
  ModalHeader,
  ModalContent,
  ModalFooter,
  Button,
  Text,
  VStack,
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Link from "next/link";
import * as C from "../../utilities/layoutConstants";
import BookingRequestForm from "./BookingRequestForm";
import Image from "next/legacy/image";
import LogInModal from "../../authentication/LogInModal";

const BookingRequestModal = ({
  show,
  close,
  practitionerId,
  profileId,
  practitionerName,
  practitionerType,
}) => {
  const loggedIn = useSelector((state) => state.user.JWTToken);

  const [bookingMade, setBookingMade] = useState({});
  const [showQuestions, setShowQuestions] = useState(false);
  const [showResponse, setShowResponse] = useState(false);
  const [bookingIsDuplicate, setBookingIsDuplicate] = useState(false);

  useEffect(() => {
    if (loggedIn && bookingMade.name) {
      bookingMade.duplicate
        ? setBookingIsDuplicate(true)
        : setBookingIsDuplicate(false);
      setShowResponse(true);
      setShowQuestions(false);
    } else {
      if (loggedIn) {
        setShowResponse(false);
        setShowQuestions(true);
      }
    }
  }, [loggedIn, bookingMade]);

  // return
  return (
    <Box mt={C.NAVBAR_HEIGHT}>
      {/*} Log In Modal {*/}
      {!loggedIn && (
        <LogInModal
          noRedirect
          title={`Please sign up or log in to contact ${practitionerName}`}
          onCloseModal={close}
          bookingRequest
          hideTherapist
          signUpChoice="bookingRequest"
          therapistName={practitionerName}
        />
      )}

      {/*} Booking Questions Modal {*/}
      {showQuestions && (
        <Modal
          isOpen={show}
          onClose={close}
          minWidth={{ base: "95%", md: "750px" }}
        >
          <ModalOverlay />

          <ModalContent maxW={{ base: "95%", md: "750px" }}>
            <ModalHeader pb={4}>
              <Text textStyle="h3">
                Your initial contact to {practitionerName}
              </Text>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody mx="auto" width="100%" pt={0}>
              <BookingRequestForm
                close={close}
                practitionerId={practitionerId}
                practitionerName={practitionerName}
                practitionerType={practitionerType}
                profileId={profileId}
                setBookingMade={setBookingMade}
              />
            </ModalBody>
            <ModalFooter></ModalFooter>
          </ModalContent>
        </Modal>
      )}

      {/*} Booking Response Modal {*/}
      {showResponse && (
        <Modal isOpen={show} onClose={close}>
          <ModalOverlay />

          <ModalContent maxW={{ base: "95%", md: "500px" }}>
            <ModalCloseButton />
            <ModalBody mx="auto" width="100%">
              {!bookingIsDuplicate && (
                <VStack>
                  <Image
                    src="/static/icons/CheckCircleGreen.png"
                    alt="Checked circle"
                    width="100px"
                    height="100px"
                    color="brand.400"
                  />

                  <Text textStyle="body1" py="20px">
                    Your request was sent to {bookingMade.name}. You should hear
                    back within 48 hours.
                    <br></br>
                    <br></br>
                    You can interact with your therapists from your
                    &quot;Therapy dashboard&quot;, accessed from the top right
                    of the screen.
                  </Text>
                  <Box
                    w="100%"
                    display="flex"
                    justifyContent="center"
                    my="24px"
                  >
                    <Link
                      prefetch={false}
                      href={{
                        pathname: `/accounts/user-account/dashboard/messages`,
                        query: {
                          user: practitionerId,
                        },
                      }}
                    >
                      <Button variant="solid">Go to therapist chat</Button>
                    </Link>
                  </Box>
                </VStack>
              )}
              {bookingIsDuplicate && (
                <VStack>
                  <Image
                    src="/static/icons/AlertCircleGreen.png"
                    alt="Alert circle"
                    width={100}
                    height={100}
                    color="brand.400"
                  />
                  <Text textStyle="body1" paddingTop="20px">
                    You already have an outstanding request from{" "}
                    {bookingMade.name}. You should expect a response within
                    24-48 hours.
                  </Text>
                  <Text textStyle="body1" paddingBottom="20px">
                    If it is taking a while longer, you can send your therapist
                    a message or talk to us.
                  </Text>

                  <Box
                    w="100%"
                    display="flex"
                    justifyContent="center"
                    my="24px"
                  >
                    <Button variant="outline" w="48%" onClick={() => close()}>
                      Ok, got it
                    </Button>
                    <Link
                      href="/accounts/user-account/dashboard"
                      prefetch={false}
                    >
                      <Button variant="solid" w="48%">
                        Send message
                      </Button>
                    </Link>
                  </Box>
                </VStack>
              )}
            </ModalBody>
            <ModalFooter></ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
};

export default BookingRequestModal;
